import useGetApi from "../useGetApi"
import useMutateApi from "../useMutateApi"
import getUrl from "api/apiMap"
import apiEndpoints from "api/utils/apiEndpoints"
import queryKeys from "api/utils/queryKeys"

export const useGetAllLockableFields = () => {
  return useGetApi(getUrl(apiEndpoints.allLockableFields), queryKeys.adminLockedFields.allLockableFields)
}

export const useGetLockedFields = () => {
  return useGetApi(getUrl(apiEndpoints.lockedFields), queryKeys.adminLockedFields.lockedFields)
}

export const usePostLockedFields = () => {
  return useMutateApi({
    method: "post",
    apiEndpoint: getUrl(apiEndpoints.lockedFields),
    invalidateQueries: [queryKeys.adminLockedFields.lockedFields],
    successMsg: "Successfully updated locked fields.",
  })
}

export const useDeleteLockedFields = () => {
  return useMutateApi({
    method: "delete",
    apiEndpoint: getUrl(apiEndpoints.lockedFields),
    invalidateQueries: [queryKeys.adminLockedFields.lockedFields],
    successMsg: "Successfully deleted locked fields.",
  })
}
